'use client';

import { useState } from 'react';
import { useXpStatus, useXpConfig, useLevelBonuses, useClaimLevelBonus } from '../../queries/useProfileQueries';

export const useLevelInfoScreenData = () => {
  const { data: xpStatus, isLoading: isLoadingXpStatus } = useXpStatus();
  const { data: xpConfig, isLoading: isLoadingXpConfig } = useXpConfig();
  const { data: levelBonuses, isLoading: isLoadingLevelBonuses } = useLevelBonuses();

  const claimLevelBonusMutation = useClaimLevelBonus();
  const [claimingLevel, setClaimingLevel] = useState<number | null>(null);

  const loading = isLoadingXpStatus || isLoadingXpConfig || isLoadingLevelBonuses;

  const claimLevelBonus = async (level: number) => {
    setClaimingLevel(level);
    try {
      await claimLevelBonusMutation.mutateAsync(level);
    } finally {
      setClaimingLevel(null);
    }
  };

  return {
    xpStatus,
    xpConfig,
    levelBonuses,
    loading,
    error: null,
    loadData: () => {},
    claimLevelBonus,
    claimingLevel,
  };
};
